import { GET_TRACKING_PLACES } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_TRACKING_PLACES] (state, trackingPlaces) {
    state.all = trackingPlaces
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/trackingPlaces.js